/**
 * record-row-checkbox.js
 */

import React from 'react';
import { 
  Checkbox,
  Tooltip,
} from '@mui/material';


export default (props) => {
  const {
    id,
    type,
    isSelected,
    isDisabled,
    disabledReason,
    onChange,
  } = props;

  return (
    <Tooltip
      arrow
      placement="top"
      title={disabledReason || <>Select records to print and<br />then click Create Report</>}
      style={{ position: 'relative', pointerEvents: 'auto' }}
    >
      <div>
        <Checkbox
          color="primary"
          checked={isSelected}
          value={isSelected}
          disabled={isDisabled}
          onChange={(e, v) => onChange(type, id, v)}
          data-testtype="record-row-checkbox"
        />
      </div>
    </Tooltip>
  );
}